// Apariencia (tema y paleta) de este navegador.
import { useSyncExternalStore } from 'react';

import { KEYS, readJSON, writeJSON } from '../lib/storage';

export type Tema = 'light' | 'dark' | 'system';
export type Paleta = 'indigo' | 'cian' | 'ambar' | 'esmeralda' | 'rubi';

export const PALETAS: { id: Paleta; nombre: string; muestra: string }[] = [
  { id: 'indigo', nombre: 'Índigo', muestra: 'oklch(.5 .16 272)' },
  { id: 'cian', nombre: 'Cian', muestra: 'oklch(.52 .13 222)' },
  { id: 'ambar', nombre: 'Ámbar', muestra: 'oklch(.72 .15 68)' },
  { id: 'esmeralda', nombre: 'Esmeralda', muestra: 'oklch(.52 .12 162)' },
  { id: 'rubi', nombre: 'Rubí', muestra: 'oklch(.52 .18 6)' },
];

type Apariencia = { tema: Tema; paleta: Paleta };
let estado = readJSON<Apariencia>(KEYS.apariencia, { tema: 'system', paleta: 'indigo' });
const subs = new Set<() => void>();

function aplicar() {
  const root = document.documentElement;
  if (estado.tema === 'system') delete root.dataset.theme;
  else root.dataset.theme = estado.tema;
  root.dataset.pal = estado.paleta;
}

export function setApariencia(p: Partial<Apariencia>) {
  estado = { ...estado, ...p };
  writeJSON(KEYS.apariencia, estado);
  aplicar();
  subs.forEach((s) => s());
}

export const useApariencia = () =>
  useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    () => estado,
  );

if (typeof document !== 'undefined') aplicar();
